import React from "react";
import useLiveCallTasks from "./useLiveCallTasks";
import TaskStatusContainer from "./TaskStatusContainer";
import { Grid } from "@mui/material";
import LiveCallTaskItem from "./LiveCallTaskItem";
import LoadingSpinner from "components/LoadingSpinner";
import LiveCallTaskSearchFilter from "./LiveCallTaskSearchFilter";
import moment from "moment";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import "./LiveCallTasks.css";

const DisconnectedDateHeader = ({ date }) => (
  <div className="sticky-account-header">
    <LinkOffIcon
      className="sticky-account-header__accent"
      sx={{ fontSize: 18 }}
    />
    <span>Disconnected since:</span>
    <span className="sticky-account-header__accent">
      {date ? moment(date, "YYYY-MM-DD").format("MM/DD/YYYY") : "N/A"}
    </span>
    <span className="sticky-account-header__line" />
  </div>
);

const LiveCallTasks = () => {
  const {
    isLoading,
    isFetching,
    tasksByStatus,
    selectedAccount,
    liveCallTaskCount,
    patientNameSearch,
    selectedAdvisory,
    selectedMonthlyBatteryCheck,
    selectedDisconnectedDateOrder,

    handleCallLogSubmit,
    handleSearchPatient,
    handleAccountFilter,
    handleAdvisoryFilter,
    handleMonthlyBatteryCheckFilter,
    handleDisconnectedDateOrder,
  } = useLiveCallTasks();

  return (
    <div className="live-call__container">
      <LiveCallTaskSearchFilter
        selectedAccount={selectedAccount}
        patientNameSearch={patientNameSearch}
        handleSearchPatient={handleSearchPatient}
        handleAccountFilter={handleAccountFilter}
        selectedAdvisory={selectedAdvisory}
        handleAdvisoryFilter={handleAdvisoryFilter}
        selectedMonthlyBatteryCheck={selectedMonthlyBatteryCheck}
        handleMonthlyBatteryCheckFilter={handleMonthlyBatteryCheckFilter}
        selectedDisconnectedDateOrder={selectedDisconnectedDateOrder}
        handleDisconnectedDateOrder={handleDisconnectedDateOrder}
      />
      <Grid
        container
        spacing={1}
        style={{
          flex: 1,
          padding: 16,
        }}
      >
        <Grid item xs={4} style={{ display: "flex", flexDirection: "column" }}>
          <TaskStatusContainer
            status="to do"
            count={liveCallTaskCount?.["todo"]}
          >
            {tasksByStatus?.["todo"]?.length ? (
              tasksByStatus["todo"]?.map((task) => (
                <>
                  <DisconnectedDateHeader date={task?.disconnected_date} />

                  {task?.patients?.map((patientInfo) => (
                    <LiveCallTaskItem
                      patient={patientInfo}
                      status="todo"
                      handleCallLogSubmit={handleCallLogSubmit}
                    />
                  ))}
                </>
              ))
            ) : (
              <div className="no-tasks">
                {isLoading || isFetching ? (
                  <LoadingSpinner />
                ) : (
                  "No tasks found"
                )}
              </div>
            )}
          </TaskStatusContainer>
        </Grid>

        <Grid item xs={4}>
          <TaskStatusContainer
            status="Need Follow-Up"
            count={liveCallTaskCount?.["need_follow_up"]}
          >
            {tasksByStatus?.["need_follow_up"]?.length > 0 ? (
              tasksByStatus["need_follow_up"].map((task) => {
                return (
                  <>
                    <DisconnectedDateHeader date={task?.disconnected_date} />

                    {task?.patients?.map((patientInfo, index) => (
                      <LiveCallTaskItem
                        key={index}
                        patient={patientInfo}
                        status="need_follow_up"
                        handleCallLogSubmit={handleCallLogSubmit}
                      />
                    ))}
                  </>
                );
              })
            ) : (
              <div className="no-tasks">
                {isLoading || isFetching ? (
                  <LoadingSpinner />
                ) : (
                  "No tasks found"
                )}
              </div>
            )}
          </TaskStatusContainer>
        </Grid>

        <Grid item xs={4}>
          <TaskStatusContainer
            status="Completed"
            count={liveCallTaskCount?.["completed"]}
          >
            {tasksByStatus?.["completed"]?.length > 0 ? (
              tasksByStatus["completed"]?.map((task) => (
                <>
                  <DisconnectedDateHeader date={task?.disconnected_date} />

                  {task?.patients?.map((patientInfo) => (
                    <LiveCallTaskItem
                      patient={patientInfo}
                      status="completed"
                    />
                  ))}
                </>
              ))
            ) : (
              <div className="no-tasks">
                {isLoading || isFetching ? (
                  <LoadingSpinner />
                ) : (
                  "No tasks found"
                )}
              </div>
            )}
          </TaskStatusContainer>
        </Grid>
      </Grid>
    </div>
  );
};

export default LiveCallTasks;
